var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 10,
    viewBox: "0 0 7 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7242_802020)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_7242_802020)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_7242_802020)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.07685 5.38915L1.63541 9.8316C1.53165 9.93414 1.39166 9.99164 1.24578 9.99164C1.09991 9.99164 0.959911 9.93414 0.856155 9.8316L0.349488 9.32493C0.244314 9.22219 0.182949 9.08276 0.178235 8.93581C0.173675 8.86425 0.18493 8.79256 0.2112 8.72583C0.237469 8.6591 0.27811 8.59898 0.330234 8.54973L3.8769 5.00307L0.330234 1.4564C0.278248 1.40654 0.237933 1.34579 0.21218 1.27852C0.186427 1.21125 0.175873 1.13911 0.181275 1.06728C0.184947 0.918914 0.246393 0.777843 0.352528 0.674106L0.859195 0.167439C0.962561 0.0641623 1.1027 0.00614929 1.24882 0.00614929C1.39494 0.00614929 1.53508 0.0641623 1.63845 0.167439L6.07685 4.61091C6.13387 4.65846 6.17974 4.71796 6.21122 4.7852C6.2427 4.85244 6.25902 4.92578 6.25902 5.00003C6.25902 5.07427 6.2427 5.14761 6.21122 5.21485C6.17974 5.28209 6.13387 5.3416 6.07685 5.38915Z",
    fill: "#BCBCBB"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7242_802020"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.08,
    height: 10,
    fill: "white",
    transform: "translate(0.180176)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_7242_802020"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.08,
    height: 10,
    fill: "white",
    transform: "translate(0.180176)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_7242_802020"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6.08,
    height: 9.98336,
    fill: "white",
    transform: "translate(0.180176 0.00831604)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.27e4c3a4.svg";
export { ForwardRef as ReactComponent };